// extracted by mini-css-extract-plugin
export default {"breadcrumb":"w9kL52zjPh","commentsSectionContainer":"yHW9s7eqBv","withMinHeight":"w4ijwDiZvT"};